module.exports = __webpack_public_path__ + "static/smn_logo-b76554e30034154cc2e48a354210255d.png";